export default "__VITE_ASSET__B8Vek4K5__"